// extracted by mini-css-extract-plugin
export default {"subtitle":"MedicineList_subtitle__BTjX+","loadingSpinner":"MedicineList_loadingSpinner__zzHVK"};